/** @typedef {import('headlight-configurable-application').Pict} Pict */

const MaterialsSelectorDisplayInputHandler = require('./PictProvider-InputType-MaterialsEntityDisplay.js');

// NOTE: This entity selector does not support Tabular Data at this time.
class MaterialsSelectorTestDisplayInputHandler extends MaterialsSelectorDisplayInputHandler
{
	constructor(pFable, pOptions, pServiceHash)
	{
		if (!pOptions)
		{
			pOptions = { };
		}
		pOptions.Entity = 'Test'; //TODO: use default options for this?
		super(pFable, pOptions, pServiceHash);

		/** @type {Pict} */
		this.pict;
	}

	getSelectInputHTMLID(pInputHTMLID)
	{
		return `#MATERIALS-ENTITY-DISPLAY-FOR-${pInputHTMLID}`;
	}

	getTabularSelectInputID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DATA-${pInputHTMLID}-${pRowIndex}`;
	}

	getTabularSelectDropdownID(pInputHTMLID, pRowIndex)
	{
		return `#MATERIALS-ENTITY-DISPLAY-TABULAR-DROPDOWN-${pInputHTMLID}-${pRowIndex}`;
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pTransactionGUID);
	}

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} pRowIndex - The row index parameter.
	 * @param {string} pTransactionGUID - The transaction GUID.
	 * @return {boolean}
	 */
	onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID)
	{
		//FIXME: base class doesn't allow this to be async - changed to run async safely for now, but not sure if this creates timing problems
		this._onDataMarshalToForm(pView, pGroup, null, pInput, pValue, pHTMLSelector, pRowIndex).catch((pError) =>
		{
			this.pict.log.error(`Error in onDataMarshalToForm: ${pError}`);
		});
		return super.onDataMarshalToFormTabular(pView, pGroup, pInput, pValue, pHTMLSelector, pRowIndex, pTransactionGUID);
	}

	/**
	 * @param {Record<string, any>} pInput
	 */
	_getEntity(pInput)
	{
		return (pInput?.PictForm?.Entity) || this.options.Entity || null;
	}


	// NOTE: This all is duplicated from the base EntityDisplay class becuase we need to be able to pass IdentityField as 'Hash' for Tests, should refactor later

	/**
	 * Marshals data to the form for the given input.
	 *
	 * @param {Object} pView - The view object.
	 * @param {Object} pGroup - The group object.
	 * @param {Object} pRow - The row object.
	 * @param {Object} pInput - The input object.
	 * @param {any} pValue - The value to be marshaled.
	 * @param {string} pHTMLSelector - The HTML selector.
	 * @param {number} [pRowIndex] - The row index parameter.
	 * @return {Promise<boolean>}
	 */
	async _onDataMarshalToForm(pView, pGroup, pRow, pInput, pValue, pHTMLSelector, pRowIndex)
	{
		// Tabular Print/Read renders the static `...TABULAR-DATA-...` div, not a `...DROPDOWN-...` select2 node.
		const inputMethod = pRowIndex != null ? 'getTabularSelectInputID' : 'getSelectInputHTMLID';
		// Try to get the input element before we do anything else
		const tmpInputSelectElements = this.pict.ContentAssignment.getElement(this[inputMethod](pInput.Macro.RawHTMLID, pRowIndex));
		if (!tmpInputSelectElements || tmpInputSelectElements.length < 1)
		{
			return false;
		}
		/** @type {HTMLSelectElement} */
		const tmpInputSelectElement = tmpInputSelectElements[0];
		// if we have a value (ID), go fetch the Entity for display (Name, etc.)
		if (pValue)
		{
			const { Record: tmpEntity, DisplayName: tmpDisplayName } = await this.pict.providers.Select2Util.getEntityWithDisplayAsync(this._getEntity(pInput), pValue,
			{
				IdentityField: 'Hash',
				JoinEntity: pInput.PictForm.JoinEntity,
				JoinEntityFirst: pInput.PictForm.JoinEntityFirst ?? true,
				JoinField: pInput.PictForm.JoinField ? pInput.PictForm.JoinField : pInput.PictForm.JoinEntity ? `ID${ pInput.PictForm.JoinEntity }` : null,
				EntityDisplayField: pInput.PictForm.EntityDisplayField,
				JoinEntityDisplayField: pInput.PictForm.JoinEntityDisplayField,
				EntityTagLast: pInput.PictForm.EntityTag && pInput.PictForm.EntityTagLast,
			});
			// if we have an EntityTag, display that as a tag along with the Name
			if (pInput.PictForm.EntityTag)
			{
				let tmpDisplayTemplate = '';
				if (tmpInputSelectElement.tagName === 'DIV')
				{
					tmpDisplayTemplate = this.pict.providers.Select2Util.buildSelect2CompoundDisplayTemplate(
						tmpEntity[pInput.PictForm.EntityTag] || 'N/A',
						tmpDisplayName || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]),
						false,
						tmpEntity.EntityTagLast,
					);
				}
				else
				{
					tmpDisplayTemplate = pValue || (`Unnamed ${ this._getEntity(pInput) } #` + tmpEntity[`ID${ this._getEntity(pInput) }`]);
				}
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayTemplate);
			}
			else
			{
				this.pict.ContentAssignment.assignContent(tmpInputSelectElement, tmpDisplayName);
			}
		}
		else
		{
			this.pict.ContentAssignment.assignContent(tmpInputSelectElement, '');
		}
	}
}

module.exports = MaterialsSelectorTestDisplayInputHandler;
